
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_qk1j1_129et_27",
  "textarea": "awsui_textarea_qk1j1_129et_31",
  "textarea-resize-both": "awsui_textarea-resize-both_qk1j1_129et_86",
  "textarea-resize-horizontal": "awsui_textarea-resize-horizontal_qk1j1_129et_89",
  "textarea-resize-vertical": "awsui_textarea-resize-vertical_qk1j1_129et_92",
  "textarea-resize-none": "awsui_textarea-resize-none_qk1j1_129et_95",
  "textarea-readonly": "awsui_textarea-readonly_qk1j1_129et_104",
  "textarea-invalid": "awsui_textarea-invalid_qk1j1_129et_141",
  "textarea-warning": "awsui_textarea-warning_qk1j1_129et_150"
};
  